"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Password_1 = require("./Password");
exports.default = Password_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/Password/index.js
// module id = 1720
// module chunks = 8